import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import "./breadcrumbs.scss";

const FourBreadcrumb = ({
  firstName,
  firstLink,
  firstOnClick,
  secondName,
  secondLink,
  secondOnClick,
  activeName,
}) => {
  return (
    <div role="presentation" className="breadcrumb">
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/" className="link">
          Home
        </Link>
        <Link to={`/${firstLink}`} className="link" onClick={firstOnClick}>
          {firstName}
        </Link>
        <Link to={`/${secondLink}`} className="link" onClick={secondOnClick}>
          {secondName}
        </Link>
        <div aria-current="page">{activeName}</div>
      </Breadcrumbs>
    </div>
  );
};

export default FourBreadcrumb;
